<template lang="html">
  <div>
    <h3>Aprovação</h3>
    <lottie-component v-if="loadingApprove"
                      :options="loadingOptions"
                      :height="200"
                      :width="200" />
    <div v-else>
      <b-form-group
        id="input-group-1"
        label="Nome Completo"
        label-for="input-1"
      >
        <b-form-input v-model="name"></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Nome da Mãe"
        label-for="input-1"
      >
        <b-form-input v-model="motherName"></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-1"
        label="Data de Nascimento"
        label-for="input-1"
      >
        <input-component id="birthDate" placeholder="__/__/____" mask="##/##/####" type='text' @updateValue="val => birthDate = val" :model="birthDate"/>
      </b-form-group>
      <b-form-group
        label="Comentário"
        label-for="commentTextarea"
      >
        <b-form-textarea id="commentTextarea" :rows="3" placeholder="Adicione informações a respeito da Aprovação/Rejeição" v-model="comment"></b-form-textarea>
      </b-form-group>
      <div class="approval-button-group">
        <div class="btn-group">
          <b-button v-if="showApprove" variant="success" @click="approve('BoletoFlex FIDC')"><i class="fa fa-thumbs-o-up"></i> APROVAR (BoletoFlex FIDC)</b-button>
          <b-link v-if="showApprove === false && tx.sellerName === 'Mobly'" class="expired_order_button" target="_blank" :href="'https://api.whatsapp.com/send?phone=55' + user.phoneNumber + '&text=' + text"><i class="micon-whatsapp"></i>Pedido expirado</b-link>
          <b-button style="margin-left: 5px;" variant="danger" @click="reject"><i class="fa fa-thumbs-o-down"></i> Rejeitar</b-button>
        </div>
        <div class="btn-group">
          <b-button v-if="showApprove" class="bg-light text-dark" @click="saveValidationApprovalData()"><i class="fa fa-floppy-o" v-if="!saveLoading"></i><b-spinner v-if="saveLoading" style="width: 24px; height: 24px;" small label="Small Spinner" type="grow"></b-spinner> Salvar</b-button>
          <b-button style="margin-left: 5px;" v-b-toggle.collapse-blacklist class="bg-dark text-white" v-if="isBlacklist === undefined"><i class="fa fa-ban"></i> Bloquear</b-button>
        </div>
      </div>
      <b-collapse id="collapse-blacklist" class="mt-2" v-if="isBlacklist === undefined">
        <b-card>
          <p class="card-text">Bloquear pessoa (Blacklist)</p>
          <b-form-select v-model="selected" :options="options"></b-form-select>
           <b-form-textarea v-if="selected != null" class="blacklist_comment" :rows="3" placeholder="Adicione informações a respeito do Bloqueio" v-model="blacklistComment"></b-form-textarea>
          <b-button v-if="selected != null" class="blacklist_confirm_button bg-dark text-white" @click="addBlacklist"><i class="fa fa-ban"></i>Bloquear</b-button>
        </b-card>
      </b-collapse>
    </div>
    <div>
      {{ message }}
    </div>
    <div class="blacklist_message" v-if="isBlacklist">
      Adicionado a Blacklist
    </div>
    <ul>
      <li v-for="i in installments" v-bind:key="i.index">
        <a :href="i.url" target="_blank">Boleto {{ i.index }}</a>
      </li>
    </ul>
    <div v-if="installments" v-for="phone in phones" v-bind:key="phone.id">
      <b-button block v-if="phone.defaultPhoneNumber" variant="outline-success" :href="'https://api.whatsapp.com/send?phone=55' + phone.phoneNumber + '&text=' + approvedText +
            encodeURIComponent('https://meu.boletoflex.com/#/' + uuid)" target="_blank">Msg Aprovação<br/><i class="micon-whatsapp"></i></b-button>
      <b-button block v-if="phone.defaultPhoneNumber" variant="outline-success" class="mr-1"  @click="sendWhatsappMessage(phone.phoneNumber, + approvedText + ' https://meu.boletoflex.com/#/' + uuid)">
        Msg Aprovação (NOVO)<br><i class="micon-whatsapp" v-if="!loadingWhats"></i>
        <b-spinner style="width: 26px; height: 26px;" v-if="loadingWhats" small class="whatsapp-message-loading"/>
      </b-button>
      <b-button block v-if="phone.defaultPhoneNumber" variant="outline-success" :href="'https://api.whatsapp.com/send?phone=55' + phone.phoneNumber + '&text=Obrigado por ter escolhido a BoletoFlex.%20Poderia, por gentileza, responder a nossa Pesquisa de Satisfação?%20' +
            encodeURIComponent('https://forms.gle/wiKW3F6yicq86F5x7')" target="_blank">NPS<br/><i class="micon-whatsapp" ></i></b-button>
      <b-button block v-if="phone.defaultPhoneNumber" variant="outline-success" class="mr-1"  @click="sendWhatsappMessage(phone.phoneNumber, 'Obrigado por ter escolhido a BoletoFlex. Poderia, por gentileza, responder a nossa Pesquisa de Satisfação? https://forms.gle/wiKW3F6yicq86F5x7')">
        NPS (NOVO)<br><i class="micon-whatsapp" v-if="!loadingWhats"></i>
        <b-spinner style="width: 26px; height: 26px;" v-if="loadingWhats" small class="whatsapp-message-loading"/>
      </b-button>
    </div>
    <div v-if="(!installments || (installments && installments.length === 0)) && ccbNumber">
      <b-button variant="success" @click="billing()">Regerar boletos</b-button>
    </div>
  </div>
</template>
<script>
import animationLoading from '../../../assets/animation/loading.json'
import Button from '../../partial/button/Button.vue'
import Input from '../../partial/form/Input.vue'
import Lottie from 'vue-lottie'
import moment from 'moment-timezone'
import { extractFirstName } from '../../../utils/extractFirstName'

export default {
  props: ['name', 'cpf', 'motherName', 'birthDate', 'comment', 'phoneNumber', 'tx', 'backCheck', 'user', 'reference'],

  components: {
    'button-component': Button,
    'lottie-component': Lottie,
    'input-component': Input
  },
  data () {
    return {
      text: `Olá ${this.extractFirstName(this.user.name)}, tudo bem? Aqui é do Boleto Parcelado da BoletoFlex. Nós recebemos seu pedido ${this.reference} na Mobly, mas infelizmente ele foi cancelado na loja, você poderia refazer o pedido?`,
      approvedText: this.extractFirstName(this.user.name) + ', seu parcelamento para o pedido *' + this.reference + '* na *' + this.tx.sellerFriendlyName + '* foi aprovado! A loja já está liberada para seguir com a entrega e você deve receber um e-mail da *' + this.tx.sellerFriendlyName + '* com a confirmação. Nos informe qualquer mudança no status do seu pedido.%0A%0AAqui está o link com todos os seus boletos para pagamento, onde você pode ver o status e vencimento de cada um. Enviamos também para seu e-mail uma cópia do contrato de parcelamento. Qualquer dúvida pode nos chamar =).%0A%0A',
      loadingApprove: false,
      loadingOptions: { animationData: animationLoading, loop: true },
      message: null,
      isBlacklist: undefined,
      blacklistComment: null,
      installments: null,
      uuid: null,
      ccbNumber: null,
      phones: [],
      showApprove: true,
      selected: null,
      loadingWhats: false,
      sellerStatus: null,
      saveLoading: false,
      options: [
        { value: null, text: 'Selecione o período' },
        { value: new Date().setDate(new Date().getDate() + 1), text: '1 Dia' },
        { value: new Date().setDate(new Date().getDate() + 7), text: '1 Semana' },
        { value: new Date().setDate(new Date().getDate() + 31), text: '1 Mês' }
      ]
    }
  },
  mounted () {
    this.$root.$on('sellerStatus', (sellerStatus) => {
      this.sellerStatus = sellerStatus
      this.verifyStatusMarabraz(this.tx.sellerName, this.sellerStatus)
    })

    this.uuid = this.$route.params.txid
    moment.locale('pt-br')
    this.$root.$on('loadphone', () => {
      this.loadPhones()
    })
    this.loadPhones()
    this.getBlacklist()
    this.orderExpiredMobly()
  },
  methods: {
    saveValidationApprovalData () {
      this.saveLoading = true
      this.$http.post('api/validations/' + this.$route.params.txid + '/save', {
        name: this.name,
        birthDate: this.birthDate,
        comment: this.comment,
        motherName: this.motherName
      }).then(function (res) {
        this.saveLoading = false
        this.$bvToast.toast('Dados salvos com sucesso', {
          autoHideDelay: 5000,
          variant: 'success'
        })
      })
        .catch(function (res) {
          this.saveLoading = false
          console.log('Error')
          console.log(res)
        })
    },
    verifyStatusMarabraz (sellerName, sellerStatus) {
      if (sellerName === 'Marabraz' && sellerStatus === false) {
        this.showApprove = false
      }
    },
    orderExpiredMobly () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/mobly')
        .then(function (res) {
          this.showApprove = res.data.showApprove
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    addBlacklist () {
      this.$bvModal.msgBoxConfirm('Você confirma a adição na Blacklist?', {
        title: 'CONFIRMAÇÃO',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM, adionar na Blacklist',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false
      })
        .then(value => {
          if (value === true) {
            this.loadingApprove = true
            this.$http.post('api/blacklist/' + this.$route.params.txid, {
              blacklistPeriod: new Date(this.selected),
              cpf: this.cpf,
              phone: this.phoneNumber,
              comment: this.blacklistComment,
              device: this.tx.userAgent,
              isBlacklist: true
            })
              .then(function (res) {
                this.loadingApprove = false
                this.getBlacklist()
                this.$bvToast.toast('Adicionado com sucesso', {
                  autoHideDelay: 5000,
                  variant: 'success'
                })
              })
              .catch(function (res) {
                console.log('Error')
                console.log(res)
                this.$bvToast.toast(res, {
                  title: 'Erro ao adicionar na Blacklist',
                  autoHideDelay: 5000,
                  variant: 'danger'
                })
              })
          }
        })
        .catch(err => {
          console.log('Error: ' + err)
        })
    },
    getBlacklist () {
      this.$http.get('api/blacklist/' + this.$route.params.txid)
        .then(function (res) {
          this.isBlacklist = res.data.data[0].isBlacklist
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    billing () {
      this.loadingApprove = true
      this.$http.post('ccb/' + this.ccbNumber + '/billing')
        .then(function (res) {
          this.installments = res.data.installments
          this.loadingApprove = false
          console.log('OK')
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.loadingApprove = false
          console.log('Erro')
        })
    },
    approve (fdic) {
      var birthDateInput = document.getElementById('birthDate')

      if (!this.birthDate) {
        this.$bvToast.toast('Data de nascimento é obrigatório !', {
          autoHideDelay: 5000,
          variant: 'danger'
        })
        birthDateInput.classList.add('input-error')
      } else if (this.birthDate.length < 8) {
        this.$bvToast.toast('Data de nascimento deve ter 8 dígitos !', {
          autoHideDelay: 5000,
          variant: 'danger'
        })
        birthDateInput.classList.add('input-error')
      } else {
        this.$bvModal.msgBoxConfirm('Você confirma a APROVAÇÃO deste pedido?', {
          title: 'APROVAÇÃO',
          size: 'sm',
          okVariant: 'success',
          okTitle: 'SIM, aprovar pedido',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false
        })
          .then(value => {
            console.log('UUUID ' + this.$route.params.txid)
            if (value === true) {
              this.loadingApprove = true
              // this.uuid = this.$route.params.txid
              this.$http.post('api/validations/' + this.$route.params.txid + '/approve', {fdic: fdic, name: this.name, birthDate: this.birthDate, comment: this.comment, motherName: this.motherName})
                .then(function (res) {
                  this.message = res.data.msg
                  this.installments = res.data.installments
                  this.ccbNumber = res.data.ccbNumber
                  this.loadingApprove = false
                  this.$root.$emit('disabledSplit')
                  console.log('OK')
                })
                .catch(function (res) {
                  console.log('Error')
                  console.log(res)
                  this.loadingApprove = false
                  console.log('Erro')
                  if (res.body.message && res.status !== 500) {
                    this.$bvToast.open({
                      message: res.body.message,
                      type: 'error',
                      position: 'top-right'
                    })
                  }
                })
            }
          })
          .catch(err => {
            console.log('Error: ' + err)
          })
      }
    },
    reject () {
      this.$bvModal.msgBoxConfirm('Você confirma a REJEIÇÃO deste pedido?', {
        title: 'REJEIÇÃO',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'SIM, rejeitar pedido',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false
        // centered: true
      })
        .then(value => {
          if (value === true) {
            this.loadingApprove = true
            this.$http.post('api/validations/' + this.$route.params.txid + '/reject', {comment: this.comment})
              .then(function (res) {
                this.message = res.data.msg
                this.$root.$emit('disabledSplit')
              })
              .catch(function (res) {
                console.log('Error')
                console.log(res)
              })
              .then(function (res) {
                this.$http.post('api/transactions/' + this.$route.params.txid + '/notes', {message: this.comment})
                  .then(function (res) {
                    this.$root.$emit('loadNotes')
                    this.loadingApprove = false
                  })
                  .catch(function (res) {
                    console.log('Error')
                    console.log(res)
                    this.loadingApprove = false
                  })
              })
              .catch(function (res) {
                console.log('Error')
                console.log(res)
              })
          }
        })
        .catch(err => {
          console.log('Error: ' + err)
        })
    },
    sendWhatsappMessage (phone, msg) {
      if (!this.loadingWhats) {
        this.loadingWhats = true
        this.$http.get('api/transactions/' + this.uuid)
          .then(function (res) {
            var transaction = res.data.tx.id
            var selectedPhone = phone
            this.$http.post('api/chat', {message: msg, phone: selectedPhone.toString(), transaction: transaction, username: this.$auth.user().username})
              .then(function (res) {
                this.$bvToast.toast('Mensagem enviada com sucesso', {
                  autoHideDelay: 5000,
                  variant: 'success'
                })
                this.$root.$emit('updateWhatsappMessages')
                this.loadingWhats = false
              })
              .catch(function (res) {
                this.$bvToast.toast('Erro ao enviar mensagem', {
                  autoHideDelay: 5000,
                  variant: 'danger'
                })
                console.log('Error')
                console.log(res)
                this.loadingWhats = false
              })
          })
          .catch(function (res) {
            console.log('Error')
            console.log(res)
            this.loadingWhats = false
          })
      }
    },
    loadPhones () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/phones')
        .then(function (res) {
          this.phones = res.data.list
          this.phones = this.phones.sort(function (a, b) {
            return (a.defaultPhoneNumber === b.defaultPhoneNumber) ? 0 : a.defaultPhoneNumber ? -1 : 1
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    extractFirstName
  },
  watch: {
    '$route.params.txid' () {
      this.loadPhones()
      this.orderExpiredMobly()
      this.getBlacklist()
    }
  }
}
</script>
<style lang="css">
.blacklist_comment {
  margin-top: 10px !important;
}
.blacklist_confirm_button {
  margin-top: 10px !important;
}
.blacklist_confirm_button i {
  margin-right: 5px !important;
}
.blacklist_message {
  background-color: #f86c6b !important;
  height: 77px !important;
  text-align: center !important;
  color: #FFF !important;
  padding: 25px !important;
  font-size: 18px !important;
  border-radius: 5px !important;
  margin-top: 10px !important;
}
.expired_order_button {
  font-size: 17px !important;
  margin-right: 5px !important;
  color: #f63c3a !important;
  text-decoration: none !important;
}
.expired_order_button i {
  margin-right: 5px !important;
}
.input-error {
  border: 1px solid #dc3545 !important;
}
@media(max-width: 1370px) {
  .approval-button-group div:nth-child(2) {
      display: block !important;
      margin-top: 5px !important;
   }
}
@media(min-width: 1370px) {
  .approval-button-group {
    display: flex !important;
    justify-content: space-between !important;
  }
  .approval-button-group div:nth-child(2) {
      display: inline !important;
      margin: 0px !important;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/validations/ValidationApproval.vue